// IDENTITY API (through CORE) id search / update
export const GET_BUYER_IDENTITY = "GET_BUYER_IDENTITY";
export const GET_BUYER_IDENTITY_SUCCESS = "GET_BUYER_IDENTITY_SUCCESS";
export const GET_BUYER_IDENTITY_ERROR = "GET_BUYER_IDENTITY_ERROR";

export const ERROR_BUYER_IDENTITY = "ERROR_BUYER_IDENTITY";
